/** Pure helpers for annotations and tags: no DOM, no network, so they are unit tested. */

/** 84000 -> "1:24"; 3723000 -> "1:02:03". */
export function formatOffset(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const two = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${two(m)}:${two(s)}` : `${m}:${two(s)}`;
}

/** "84" (seconds), "1:24" or "1:02:03" -> milliseconds; anything else is null, never NaN or a guess. */
export function parseOffset(text: string): number | null {
  const t = text.trim();
  if (!/^\d+(:[0-5]?\d){0,2}$/.test(t)) return null;
  const parts = t.split(":").map(Number);
  if (parts.length > 1 && parts.slice(1).some((p) => p > 59)) return null;
  const secs = parts.reduce((acc, p) => acc * 60 + p, 0);
  return secs * 1000;
}

/**
 * A tag name, tidied — or null for input the server would refuse, so the UI can say so first.
 *
 * Trimmed and with runs of whitespace collapsed, and otherwise left exactly as typed. It used
 * to lowercase and to demand `[a-z0-9 _-]`, which was the old column's CHECK; the name now
 * lives on its own record, is stored as written and matched case-insensitively, so flattening
 * it here would only make this screen disagree with the others about what a folder is called —
 * and would refuse names the server takes, like `Café` or `市場`.
 */
export function normalizeTag(input: string): string | null {
  const t = input.trim().replace(/\s+/g, " ");
  return t.length >= 1 && t.length <= 40 ? t : null;
}
